import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authStore from '../../stores/authStore';
import PhoneAuth from './PhoneAuthLogin'; // adjust path
import axios from "axios";

export default function SignupForm({ activeTab, setActiveTab }) {
    const store = authStore();
    const navigate = useNavigate();

    const [activePhase, setActivePhase] = useState("username"); // "username" | "credentials"
    const [method, setMethod] = useState("email");               // "email" | "phone"
    const [usernameError, setUsernameError] = useState("");
    const [checking, setChecking] = useState(false);

    const handleUsernameNext = async (e) => {
        e.preventDefault();
        const username = store.signupForm.username?.trim();

        if (!username) {
            setUsernameError("Please enter a username.");
            return;
        }

        setChecking(true);
        setUsernameError("");

        const available = await store.checkUsername(username);

        setChecking(false);

        if (available) {
            setActivePhase("credentials");
            setUsername(username);
        }
        else setUsernameError("That username is taken.");
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        const res = await store.signup();
        if (res === "OK") navigate("/");
    };
     
    const [username, setUsername] = useState('');
    const [phone, setPhone] = useState('');
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const sendCode = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            console.log("Sending the phone #: ", phone);
            await axios.post('/send-otp', { phone });
            setActivePhase('verifyCode');

        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };
     
    const verifyCode = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const { data } = await axios.post('/signup', { username, phone, code });

            // Sync the store with the new cookie before leaving this page
            await store.checkAuth();
            navigate("/", { replace: true });

        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong');
        } finally { 
            setLoading(false);
        }
    };

    return (
        <div className="loginForm">
            {activePhase === "username" && (
                <form onSubmit={handleUsernameNext}>
                    <label>Username</label>
                    <input
                        onChange={(e) => {
                            store.updateSignupForm(e);
                            setUsernameError("");
                        }}
                        value={store.signupForm.username}
                        name="username"
                        autoComplete="username"
                    />
                    {usernameError && <p className="formError">{usernameError}</p>}
                    <div className="formButtonCenter">
                        <button type="submit" disabled={checking}>
                            {checking ? "Checking..." : "Continue"}
                        </button>
                    </div>
                </form>
            )}

            {activePhase === "credentials" && (
                <>
                    <form onSubmit={sendCode}>
                         <label>Phone Number</label>
                         <input
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <div className="termsMessage">
                            <p>
                                We will send you a code to verify your account. Or you can
                                <span
                                    className="textUnderline"
                                    onClick={() => setActivePhase("signUpWithPassword")}
                                > sign up with an email address and password</span> instead.
                            </p>
                        </div>
                        <p className="termsMessage">By signing up you agree to the
                            <a href="https://scopedtv.com/privacy-notice" target="_blank" rel="noreferrer"> Privacy Policy</a>.
                        </p>
                        <div className="formButtonCenter">
                            <button type="submit">Agree and continue</button>
                        </div>
                    </form>
                </>
            )}
            {activePhase === "signUpWithPassword" && (
                <>
                    <form onSubmit={handleSignup}>
                        <label>Email address</label>
                        <input onChange={store.updateSignupForm} value={store.signupForm.email}
                            type="email" name="email" />
                        <label>Password</label>
                        <input onChange={store.updateSignupForm} value={store.signupForm.password}
                            type="password" name="password" />
                        <p className="termsMessage">By signing up you agree to the
                            <a href="https://scopedtv.com/privacy-notice" target="_blank" rel="noreferrer"> Privacy Policy</a>.
                        </p>
                        <div className="formButtonCenter">
                            <button type="submit">Agree and continue</button>
                        </div>
                    </form>
                </>
            )}
            {activePhase === "verifyCode" && (
                <>
                    <form onSubmit={verifyCode}>
                        <p>Enter the code we sent to {phone}</p>
                        <input
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        placeholder="6-digit code"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        />
                        <button disabled={loading}>Verify</button>
                        {error && <p>{error}</p>}
                    </form>
                </>
            )}
        </div>
    );
}